var MiscCodesViewController = (function () {
    function MiscCodesViewController(env, $filter, $stateParams, $state, socket, $scope, admin, Dialog, $timeout, $q) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.Dialog = Dialog;
        this.$timeout = $timeout;
        this.$q = $q;
        this.table = { sortType: 'type', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.codes = [];
        this.codesLoaded = false;
        this.codeTypes = [];
        this.editing = false;
        this.serverError = undefined;
        this.events = { beingSaved: false };
        this.subTypes = {
            closed_codes: ['Closed'],
            dispute_codes: ['Appeal', 'Dispute', 'Exception', 'Investment Review', 'Clawback', 'Out of Policy'],
            payment_codes: ['Payment'],
            rejection_codes: ['Rejection']
        };
        this.table.headers = [{
                Type: 'type', Code: 'code', Description: 'desc', Actions: 'actions'
            }];
        this.socket.forward('config.misc_codes', this.$scope);
        this.$scope.$on('socket:config.misc_codes', function (event, payload) {
            _this.codes = payload.data;
            _this.codeTypes = payload.types;
            _this.codesLoaded = true;
            _this.selectedType = _this.codeTypes[2];
        });
    }
    MiscCodesViewController.prototype.$onInit = function () {
        this.admin.getMiscCodes(true);
    };
    MiscCodesViewController.prototype.editCode = function (code) {
        this.editing = true;
        //Combination of type and code must be unique, ie: 'dispute_codes' and 'D001'
        this.editCodePack = this.getCode(this.selectedType, code);
    };
    MiscCodesViewController.prototype.getNextCode = function (type, subtype) {
        var prefix = angular.isUndefined(subtype) ? type.charAt(0).toUpperCase() : subtype.charAt(0);
        //If no codes yet...
        if (this.codes[type].codes.length === 0) {
            return prefix + '001'; //Return x001
        }
        //Otherwise work out what the next will be
        var lowest = 0;
        if (this.codes[type].codes.length > 0) {
            //lowest = parseInt(this.codes[type].codes[0].code.substring(1), 10); //get the first index
            if (subtype !== null) {
                this.codes[type].codes.some(function (c) {
                    if (c.type.charAt(0) === prefix) {
                        lowest = parseInt(c.code.substring(1), 10);
                        return true;
                    }
                });
            }
            //If here and still 0 then there's no match
            if (lowest === 0) {
                return prefix + '001'; //Return x001
            }
            var highest_1 = lowest;
            var next = void 0;
            angular.forEach(this.codes[type].codes, function (c) {
                var stp = c.type.charAt(0);
                if (prefix === stp) {
                    var tNum = parseInt(c.code.substring(1), 10);
                    if (tNum < lowest) {
                        lowest = tNum;
                    }
                    if (tNum > highest_1) {
                        highest_1 = tNum;
                    }
                }
            });
            //Code will be a letter followed by 3 numbers
            if (lowest !== 1) {
                //if lowest is x004 for example...it means 1, 2 and 3 have been deleted, so return 3
                next = lowest - 1; //Probably will remove this...
            }
            else {
                next = highest_1 + 1;
            }
            return prefix + ('000' + next).substring(('000' + next).length - 3);
        }
    };
    MiscCodesViewController.prototype.refreshCodes = function () {
        var _this = this;
        //After an edit/delete or new code, and once success back from server, update content in browser
        var index = 0;
        if (this.editCodePack.delete) {
            this.codes[this.editCodePack.code_set].codes.some(function (code) {
                if (code.code === _this.editCodePack.code) {
                    _this.codes[_this.editCodePack.code_set].codes.splice(index, 1);
                    return true; //break loop
                }
                index++;
            });
        }
        else {
            if (this.editCodePack.new) {
                //new
                var newb = {
                    code: this.editCodePack.code,
                    desc: this.editCodePack.desc,
                    type: this.editCodePack.type
                };
                this.codes[this.editCodePack.code_set].codes.push(newb);
            }
            else {
                this.codes[this.editCodePack.code_set].codes.some(function (code) {
                    if (code.code === _this.editCodePack.code) {
                        code.type = _this.editCodePack.type;
                        code.code = _this.editCodePack.code;
                        code.desc = _this.editCodePack.desc;
                        return true; //break loop
                    }
                    index++;
                });
            }
        }
    };
    MiscCodesViewController.prototype.createNew = function () {
        var st = this.selectedType;
        var sub = this.subTypes[st];
        var newCode = this.getNextCode(st, st === 'dispute_codes' ? sub[0] : undefined);
        var McBundle = (function () {
            function McBundle() {
                this.code = newCode;
                this.code_set = st;
                this.desc = '';
                this.type = sub[0];
                this.new = true;
                this.delete = false;
                this.other = false;
            }
            return McBundle;
        }());
        this.editCodePack = new McBundle();
        this.editing = true;
        // this.newProfile = true;
    };
    /**
     * Function to collect the user-selected code and build a bundle to be processed
     *
     * @param {string} type the misc code type, ie: payment_codes, dispute_codes
     * @param {string} code the unique code within the above array, ie: D001 would be a code within dispute_codes
     * @returns {IMiscCode}
     *
     * @memberOf MiscCodesViewController
     */
    MiscCodesViewController.prototype.getCode = function (type, code) {
        var cp;
        this.codes[type].codes.some(function (c) {
            if (c.code === code) {
                cp = c;
                return true; //break loop    
            }
        });
        var McBundle = (function () {
            function McBundle() {
                this.code = cp.code;
                this.code_set = type;
                this.desc = cp.desc;
                this.type = cp.type;
                this.new = false;
                this.delete = false;
                this.other = cp.other;
            }
            return McBundle;
        }());
        return new McBundle(); //It WILL find it
    };
    MiscCodesViewController.prototype.confirmDelete = function (event, pack) {
        var _this = this;
        var items = {
            icon: 'QUESTION',
            message: 'Are you sure you want to Delete the following code from the ' + this.admin.toProperCase(this.selectedType) + '?<p><p>' +
                '<span class="ibm-textcolor-blue-40">' + pack.code + ' - ' + pack.desc + '</span>',
            title: 'Delete Code'
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                //build the package and lose it
                _this.editCodePack = _this.getCode(_this.selectedType, pack.code);
                _this.editCodePack.delete = true;
                _this.update(_this.editCodePack);
            }
        });
    };
    MiscCodesViewController.prototype.save = function () {
        this.update(this.editCodePack);
    };
    MiscCodesViewController.prototype.update = function (codePack) {
        var _this = this;
        this.events.beingSaved = true;
        this.serverError = undefined;
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.updatePromise(codePack).then(function (data) {
            //If response from server received
            _this.events.beingSaved = false; //enable again
            _this.serverError = data.err;
            if (angular.isUndefined(data.err)) {
                //Update the code set accordingly, ie: delete, update, add
                _this.refreshCodes();
                //If editing or adding new, return to view
                _this.editing = false;
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.  Please try again.  If the problem persists, please contact the DMT System Administrators.';
        });
    };
    MiscCodesViewController.prototype.updatePromise = function (pack) {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs = 30000
        this.admin.updateMiscCodes(pack);
        this.socket.forward('config.misc_codes_update', this.$scope);
        this.$scope.$on('socket:config.misc_codes_update', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    MiscCodesViewController.$inject = ['env', '$filter', '$stateParams', '$state', 'socket', '$scope', 'admin', 'Dialog', '$timeout', '$q'];
    return MiscCodesViewController;
}());
var MiscCodesViewComponent = (function () {
    function MiscCodesViewComponent() {
        this.templateUrl = 'codes-view.html';
        this.controllerAs = 'vm';
        this.controller = MiscCodesViewController;
    }
    return MiscCodesViewComponent;
}());
angular
    .module('application')
    .component('viewMiscCodesSection', new MiscCodesViewComponent());

//# sourceMappingURL=codes.view.component.js.map
